//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mdAutocomplete from '../autocomplete/mdAutocomplete';

import autocomplete from '../../common/functions/autocomplete';
import { getClosestVueParent } from '../../common/functions/helpers';
import theme from './mdTheme';
import uniqueId from './uniqueId';

export default {
  mixins: [theme, autocomplete],
  props: {
    extensao: {
      type: Boolean,
      default: false,
    },
    mdInputId: String,
    mdInputName: String,
    mdInputPlaceholder: String,
    mdInputType: {
      type: String,
      default: 'text',
    },
    mdMax: {
      type: Number,
      default: Infinity,
    },
    mdStatic: Boolean,
    value: Array,
    prepareResponseData: Function,
    identifier: {
      value: String,
      default: 'id',
    },
  },
  data() {
    return {
      currentChip: '',
      inputId: this.mdInputId || `chips-${uniqueId()}`,
      selectedChips: this.value || [],
    };
  },
  watch: {
    value(val) {
      this.selectedChips = val || [];
      this.$refs.autocomplete.query = '';
    },
  },
  computed: {
    classes() {
      return {
        'md-static': this.mdStatic,
        'md-disabled': this.disabled,
      };
    },
    hasReachedMaxSize() {
      return this.selectedChips && this.selectedChips.length === this.mdMax;
    },
    placeholder() {
      return this.selectedChips && this.selectedChips.length ?
        this.mdInputPlaceholder :
        '';
    },
  },
  components: {
    mdAutocomplete,
  },
  methods: {
    textoChip(chip) {
      if (this.printFunction) {
        return this.printFunction(chip);
      }
      return chip[this.printAttribute];
    },
    addChip(selected = null) {
      if (selected === null || Object.keys(selected).length === 0) {
        return;
      }

      if (!this.hasReachedMaxSize) {
        let value;
        if (this.printFunction) {
          value = selected || ({ [this.printFunction()]: this.currentChip.trim() });
        } else {
          value = selected || ({ [this.printAttribute]: this.currentChip.trim() });
        }

        if (this.selectedChips.indexOf(value) < 0) {
          this.selectedChips.push(value);
          this.currentChip = null;
          this.$emit('input', this.selectedChips);
          this.$emit('change', this.selectedChips);
          this.applyAutocompleteFocus();
        }
      }
      this.$refs.autocomplete.query = '';
    },
    addExtension() {
      this.$emit('addExtension', this.currentChip);
    },
    applyAutocompleteFocus() {
      this.$nextTick(() => {
        if (this.$refs.autocomplete) this.$refs.autocomplete.onFocus();
      });
    },
    cleanField() {
      this.$refs.autocomplete.query = '';
    },
    deleteChip(chip) {
      const index = this.selectedChips.indexOf(chip);

      if (index >= 0) {
        this.selectedChips.splice(index, 1);
      }

      this.$emit('change', this.selectedChips);
      this.applyAutocompleteFocus();
    },
    deleteLastChip() {
      if (!this.currentChip) {
        this.selectedChips.pop();
        this.$emit('change', this.selectedChips);
        this.applyAutocompleteFocus();
      }
    },
    onFocus() {
      if (this.parentContainer) {
        this.parentContainer.isFocused = true;
      }
      this.$refs.autocomplete.onFocus();
    },
    onInput() {
      this.updateValues();
    },
    onBlur() {
      this.parentContainer.isFocused = false;
    },
    verifyProps() {
      if (!this.parentContainer) {
        return this.throwErrorDestroy('You should wrap the md-input in a md-input-container');
      } else if (!this.listIsEmpty && this.filterList) {
        return this.throwErrorDestroy('You should use a `filterList` function prop with the `list` prop');
      } else if (!this.fetch) {
        return this.throwErrorDestroy('You should use a `fetch` function prop');
      }
      return this;
    },
    throwErrorDestroy(errorMessage) {
      this.$destroy();
      throw new Error(errorMessage);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.parentContainer = getClosestVueParent(this.$parent, 'md-input-container');

      if (!this.listIsEmpty) {
        this.items = Object.assign([], this.list);
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/chipsautocomplete/mdChipsAutocomplete.vue?vue&type=script&lang=js&